enum GroupCreateMode {
  API = 0,
  UCG = 1
}

export default GroupCreateMode;
